import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { DEFAULT_OG_IMAGE, buildCanonicalUrl, getSeoEntry, normalizeSeoPath, shouldNoindexPath } from '@/seo';
const upsertMeta = (selector: string, attributes: Record<string, string>) => {
    let element = document.head.querySelector(selector) as HTMLMetaElement | null;
    if (!element) {
        element = document.createElement('meta');
        document.head.appendChild(element);
    }
    Object.entries(attributes).forEach(([key, value]) => {
        element!.setAttribute(key, value);
    });
};
const upsertCanonical = (href: string) => {
    let element = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!element) {
        element = document.createElement('link');
        element.rel = 'canonical';
        document.head.appendChild(element);
    }
    element.href = href;
};
const removeCanonical = () => {
    const element = document.head.querySelector('link[rel="canonical"]');
    if (element) {
        element.remove();
    }
};
const RouteSeo = () => {
    const location = useLocation();
    useEffect(() => {
        const path = location.pathname || '/';
        const normalizedPath = normalizeSeoPath(path);
        const seo = getSeoEntry(normalizedPath);
        const canonical = buildCanonicalUrl(normalizedPath);
        const noindex = shouldNoindexPath(normalizedPath, seo.noindex);
        const ogImage = seo.ogImage || DEFAULT_OG_IMAGE;
        document.title = seo.title;
        upsertMeta('meta[name="description"]', { name: 'description', content: seo.description });
        upsertMeta('meta[name="robots"]', {
            name: 'robots',
            content: noindex ? 'noindex, nofollow' : 'index, follow',
        });
        if (seo.keywords) {
            upsertMeta('meta[name="keywords"]', { name: 'keywords', content: seo.keywords });
        }
        if (noindex) {
            removeCanonical();
        } else {
            upsertCanonical(canonical);
        }
        upsertMeta('meta[property="og:title"]', { property: 'og:title', content: seo.title });
        upsertMeta('meta[property="og:description"]', { property: 'og:description', content: seo.description });
        upsertMeta('meta[property="og:type"]', { property: 'og:type', content: 'website' });
        upsertMeta('meta[property="og:image"]', { property: 'og:image', content: ogImage });
        upsertMeta('meta[property="og:url"]', { property: 'og:url', content: canonical });
        upsertMeta('meta[property="og:site_name"]', {
            property: 'og:site_name',
            content: 'آزمایشگاه تشخیص پزشکی سلامت',
        });
        upsertMeta('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary_large_image' });
        upsertMeta('meta[name="twitter:title"]', { name: 'twitter:title', content: seo.title });
        upsertMeta('meta[name="twitter:description"]', { name: 'twitter:description', content: seo.description });
        upsertMeta('meta[name="twitter:image"]', { name: 'twitter:image', content: ogImage });
    }, [location.pathname]);
    return null;
};
export default RouteSeo;
